import { Country } from './country';
export function makeCountrySpecificValue(australia, newZealand) {
  return {
    [Country.AUSTRALIA]: australia,
    [Country.NEW_ZEALAND]: newZealand
  };
}
export function resolveCountrySpecificValue(value, country) {
  return value[country];
}